import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AddRoleLayer } from '../components/roles/AddRoleLayer'

export const AddRolePage = () => {
  return (
    <MasterLayout>
        <AddRoleLayer/>
    </MasterLayout>
  )
}
